import React from 'react';
import PropTypes from 'prop-types';
import useInputEventEditor from './useInputEventEditor';
import UncontrolledCodeEditor from 'app/components/UncontrolledCodeEditor';

export default function InputEventEditor({
  defaultValue,
  setValue,
  setHasValidInput,
  trackingEventName,
  errorMsg: externalErrorMsg,
}) {
  const { errorMessage, onChange, onBlur } = useInputEventEditor({
    setValue,
    setHasValidInput,
    trackingEventName,
  });

  return (
    <UncontrolledCodeEditor
      foldable
      name="inputEvent"
      lang="json"
      errorMsg={errorMessage || externalErrorMsg}
      onBlur={onBlur}
      onChange={onChange}
      defaultValue={defaultValue}
      rows={30}
    />
  );
}

InputEventEditor.propTypes = {
  defaultValue: PropTypes.string,
  errorMsg: PropTypes.string,
  setValue: PropTypes.func.isRequired,
  setHasValidInput: PropTypes.func.isRequired,
  trackingEventName: PropTypes.string.isRequired,
};
